import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ freightCarrier: string }>;

export const DispatchSetFreightCarrier: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetFreightCarrier",
        freightCarrier: props.parameter.freightCarrier,
    });
};

export const chain = [DispatchSetFreightCarrier];

const setFreightCarrier = createHandlerChainRunner(chain, "SetFreightCarrier");
export default setFreightCarrier;
